import { useEffect, useId, useState } from 'react';
import { StripeLoader, useStripeModule } from '../../../../../context/stripe';
import axios from '../../../../../utils/axiosInstance';

import type { StripeData } from '../StripeWizard';
import type { WizardStepComponent } from '../Wizard';

import { useStripeAppearance } from '../../UseStripeAppearance';
import { PaymentDetailsStep } from './PaymentDetails.step';

export const PaymentElementWrapper: WizardStepComponent<StripeData> = (
  props,
) => {
  const [clientKey, setClientKey] = useState();

  useEffect(() => {
    const getClientKey = async () => {
      try {
        const response = await axios.get('/api/stripe/stripe-client-key', {
          withCredentials: true,
        });
        setClientKey(response.data.clientKey);
      } catch (error) {
        console.error('Error fetching Stripe client key:');
      }
    };
    getClientKey();
  }, []);

  const appearance = useStripeAppearance();
  const id = useId();
  const { Elements, stripe } = useStripeModule();
  const options = {
    clientSecret: clientKey,
    appearance,
    loader: 'never',
  } as const;

  if (!clientKey) return <StripeLoader />;
  return (
    <Elements key={id} options={options} stripe={stripe!}>
      <PaymentDetailsStep {...props} />
    </Elements>
  );
};
